module.exports = __webpack_public_path__ + "img/logo.192dfd19.png";